import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import { CmsEventAttachmentContainerModel } from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class CmsEventAttachmentService extends BaseApiTemplateService<CmsEventAttachmentContainerModel> {
  endpointSubPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'event-attachments/' ;
  readonly url = Core2Config.DOMAIN_URL + this.endpointSubPath;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + this.endpointSubPath + 'backoffice-ep';
    this.endpoint_path = this.endpointSubPath + 'backoffice-ep';
    this.httpClient = http;
  }
  
  uploadFile(formData: FormData, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpoint_path;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

  deleteAttachment(extensionGuid: string, visa: ApiVisa): Observable<ApiResponseModel<CmsEventAttachmentContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<CmsEventAttachmentContainerModel>>(
      this.apiUrl + '/' + extensionGuid,
      this.getHttpHeader(visa)
    );
  }
  
  updateFile(formData: FormData, attachmentGuid, visa: ApiVisa) {
    let url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'replace-file/backoffice-ep/' + attachmentGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpointSubPath + 'replace-file/backoffice-ep/' + attachmentGuid;
    }
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  getFile(hdrGuid: string, visa: ApiVisa): Observable<Blob> {
    let url = Core2Config.DOMAIN_URL + this.endpointSubPath + 'file/backoffice-ep/' + hdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpointSubPath + 'file/backoffice-ep/' + hdrGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }
}